export const getSearchResults = state => state.search.results;
export const isSearchFetching = state => state.search.isFetching;
